import { motion } from 'framer-motion'
import { ReactNode } from 'react'

interface SectionTitleProps {
  title: string
  subtitle?: string
  description?: string
  children?: ReactNode
  className?: string
  centered?: boolean
  colorStyle?: 'default' | 'light'
}

const SectionTitle = ({
  title,
  subtitle,
  description,
  children,
  className = '',
  centered = true,
  colorStyle = 'default'
}: SectionTitleProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className={`${centered ? 'text-center' : ''} ${className}`}
    >
      {subtitle && (
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="inline-block text-accent font-medium uppercase tracking-wider text-sm mb-2"
        >
          {subtitle}
        </motion.span>
      )}
      
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
  className="text-display font-display font-bold mb-4"
  style={{ color: colorStyle === 'light' ? '#fff' : '#254864' }}
      >
        {title}
      </motion.h2>

      {description && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className={`text-lg text-gray-600 leading-relaxed ${
            centered ? 'max-w-2xl mx-auto' : ''
          }`}
        >
          {description}
        </motion.p>
      )}

      {children && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-6"
        >
          {children}
        </motion.div>
      )}
    </motion.div>
  )
}

export default SectionTitle
